import { render, staticRenderFns } from "./tag-group.vue?vue&type=template&id=ba93f208&scoped=true"
import script from "./tag-group.vue?vue&type=script&lang=js"
export * from "./tag-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba93f208",
  null
  
)

export default component.exports